// src/modules/app-views/leads/components/CardHeaderLeadsCol2.jsx
// *******************************************************************************
// CARD HEADER: Unique ID, Phone, Email
// *******************************************************************************
// Column 2 of the leads document card header.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { FileProtectOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';
import { phoneItem } from 'layouts/Pages/PageHeader/CardHeaderColumn/items/phone';
import { emailItem } from 'layouts/Pages/PageHeader/CardHeaderColumn/items/email';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderLeadsCol2 = ({ forceShow = false, ...record }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const uniqueId = record?.uniqueId;

  const items = [
    {
      key: 'uniqueId',
      icon: <FileProtectOutlined />,
      label: uniqueId,
      tooltipText: translateX('unique_id'),
      tooltipPlacement: 'right',
      onClick: uniqueId
        ? () => appService.handleCopyToClipboard(uniqueId, 'copied')
        : null,
    },
    phoneItem(record),
    emailItem(record),
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items.filter(i => i?.label || forceShow)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderLeadsCol2;
